<script lang="ts">
  import * as Form from '$lib/components/ui/form'
  import { registerFormSchema, type RegisterFormSchema } from '$lib/zod-schemas'
  import { t } from '$lib/translations'
  import countries from '$lib/country-codes.json'
  import { UsersSourceOptions } from '$lib/pocketbase-types'
  import type { SuperForm } from 'sveltekit-superforms/client'
  import "/node_modules/flag-icons/css/flag-icons.min.css";


  export let form: SuperForm<RegisterFormSchema>

  let legalChecked = false
  let privacyChecked = false
  let bothChecked = false

  $: disabled = !bothChecked
</script>

<Form.Root {form} controlled schema={registerFormSchema} let:config>
  <div class="flex flex-col lg:flex-row justify-center items-center gap-2 lg:gap-5">
    <Form.Field {config} name="name">
      <Form.Item class="w-full">
        <Form.Label class="font-normal">{$t('common.name')}*</Form.Label>
        <Form.Input
          type="text"
          placeholder={$t('common.name')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.Validation />
      </Form.Item>
    </Form.Field>
    <Form.Field {config} name="last_name">
      <Form.Item class="w-full">
        <Form.Label class="font-normal">{$t('common.last_name')}*</Form.Label>
        <Form.Input
          type="text"
          placeholder={$t('common.last_name')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.Validation />
      </Form.Item>
    </Form.Field>
  </div>
  <div class="flex flex-col lg:flex-row justify-center items-center gap-2 lg:gap-5">
    <div class=" flex flex-row gap-5 w-full">
      <Form.Field {config} name="prefix">
        <Form.Item class="w-1/2">
          <Form.Label class="font-normal">{$t('forms.prefix')}</Form.Label>
            <Form.Select>
              <Form.SelectTrigger placeholder="{$t('forms.select_country')}" class="border border-cs-orange" />
              <Form.SelectContent class="h-56 overflow-y-scroll">
                {#each countries as country}
                  <Form.SelectItem value={country.dial_code}><span class={`fi fi-${country.code.toLowerCase()} fis mr-1`}></span>{country.name + " (" + country.dial_code + ")"}</Form.SelectItem>
                {/each}
              </Form.SelectContent>
            </Form.Select>
          <Form.Validation />
        </Form.Item>
      </Form.Field>
      <Form.Field {config} name="phone">
        <Form.Item class="w-1/2">
          <Form.Label class="font-normal">{$t('common.phone_number')}</Form.Label>
          <Form.Input
            type="text"
            placeholder={$t('common.phone_number')}
            class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
          />
          <Form.Validation />
        </Form.Item>
      </Form.Field>
    </div>
    <Form.Field {config} name="email">
      <Form.Item class="w-full">
        <Form.Label class="font-normal">{$t('common.email')}*</Form.Label>
        <Form.Input
          type="text"
          placeholder={$t('common.email')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.Validation />
      </Form.Item>
    </Form.Field>
  </div>
<div>
  <Form.Field {config} name="country">
    <Form.Item>
      <Form.Label class="font-normal">{$t('common.country')}</Form.Label>
      <Form.Select>
        <Form.SelectTrigger
          placeholder={$t('common.country')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.SelectContent class="overflow-y-auto max-h-56">
          {#each countries as country}
            <Form.SelectItem value={country.code}>{country.name}</Form.SelectItem>
          {/each}
        </Form.SelectContent>
      </Form.Select>
    </Form.Item>
  </Form.Field>
</div>
  <div class="mt-2">
  <Form.Field {config} name="source"> 
    <Form.Item>
      <Form.Label class="font-normal mt-4">{$t('common.source')}</Form.Label>
      <Form.Select>
        <Form.SelectTrigger
          placeholder={$t('common.source')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.SelectContent class="overflow-y-auto max-h-56">
          {#each Object.entries(UsersSourceOptions) as [sourceKey, sourceValue]}
            <Form.SelectItem value={sourceValue}>{$t(`common.${sourceKey}`)}</Form.SelectItem>
          {/each}
        </Form.SelectContent>
      </Form.Select>
    </Form.Item>
  </Form.Field>
</div>
  <div class="flex justify-center items-center gap-5 mt-2">
    <Form.Field {config} name="password">
      <Form.Item class="w-1/2">
        <Form.Label class="font-normal">{$t('common.password')}*</Form.Label>
        <Form.Input
          type="password"
          placeholder={$t('common.password')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.Validation />
      </Form.Item>
    </Form.Field>
    <Form.Field {config} name="passwordConfirm">
      <Form.Item class="w-1/2">
        <Form.Label class="font-normal">{$t('common.confirm_password')}*</Form.Label>
        <Form.Input
          type="password"
          placeholder={$t('common.confirm_password')}
          class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0"
        />
        <Form.Validation />
      </Form.Item>
    </Form.Field>
  </div>

  <p class="text-xs md:col-span-2">{$t('common.requireds')}</p>
  <Form.Field {config} name="accepts_commercial_comms">
    <div class="mt-2 flex flex-row gap-2 items-center md:col-span-2">
      <Form.Checkbox class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0 data-[state=checked]:bg-cs-orange m-0" />
      <Form.Label>{@html $t('common.newsletter')}</Form.Label>
      <Form.Validation />
    </div>
  </Form.Field>
  <Form.Field {config} name="legal_terms">
    <Form.Item class="flex flex-row items-center space-x-3 space-y-0 mt-4">
      <Form.Checkbox
        class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0 data-[state=checked]:bg-cs-orange m-0"
        id="legal_terms_and_conditions"
        bind:checked={legalChecked}
        onCheckedChange={() => {
        legalChecked = !legalChecked
        bothChecked = legalChecked && privacyChecked
      }}
      />
      <Form.Label for="legal_terms_and_conditions">{@html $t('common.legal_terms_and_conditions')}</Form.Label>
    </Form.Item>
    <Form.Validation />
  </Form.Field>
  <Form.Field {config} name="privacy_terms">
    <Form.Item class="flex flex-row items-center space-x-3 space-y-0 mt-4">
      <Form.Checkbox
        class="border-cs-orange focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:outline-0 data-[state=checked]:bg-cs-orange m-0"
        id="privacy_terms_and_conditions"
        bind:checked={privacyChecked}
        onCheckedChange={() => {
          privacyChecked = !privacyChecked
          bothChecked = legalChecked && privacyChecked
        }}
      />
      <Form.Label for="privacy_terms_and_conditions">{@html $t('common.privacy_terms_and_conditions')}</Form.Label>
    </Form.Item>
    <Form.Validation />
  </Form.Field>

  <div class="flex justify-center items-center my-4">
    <Form.Button {disabled} class="bg-cs-orange rounded-none hover:bg-cs-light-orange px-8 py-4">{$t('common.submit').toUpperCase()}</Form.Button>
  </div>
</Form.Root>
